import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppRoutes } from './AppRoutes';
import { DeleteAccountPage } from '../pages/DeleteAccount';
import { PrivacyPolicyPage } from '../pages/PrivacyPolicy';

export function Router(): React.ReactElement {
    return (
        <BrowserRouter>
            <Routes>
                <Route path={AppRoutes.DeleteAccount()} element={<DeleteAccountPage />} />
                <Route path={AppRoutes.PrivacyPolicy()} element={<PrivacyPolicyPage />} />
            </Routes>
        </BrowserRouter>
    )
}

